module.exports = __webpack_public_path__ + "img/gb9115_8.prt.7a74d5b6.jpg";